const navData = [
  { title: "Inicio", to: "/" },
  { title: "Tienda", to: "/collections/coffee-blends" },
  { title: "Cápsulas", to: "/collections/coffee-blends?cat=capsules" },
  { title: "Historia", to: "/about-us" },
];
export default navData;
